import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fund-3a-infobox',
  templateUrl: './fund-3a-infobox.component.html',
  styleUrls: ['../../fund.component.scss'],
  standalone: false
})
export class Fund3aInfoboxComponent {
  @Input() contribution: 'small' | 'large' | 'transfer_only';
}
